"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestRackEvGpioCommandValidation = void 0;
class TestRackEvGpioCommandValidation {
    static isValid(entity) {
        // Validate entity.contactor_en for existence and correct type.
        if (entity.contactor_en == undefined)
            return false;
        if (typeof entity.contactor_en !== "boolean")
            return false;
        // Validate entity.tms320_reset for existence and correct type.
        if (entity.tms320_reset == undefined)
            return false;
        if (typeof entity.tms320_reset !== "boolean")
            return false;
        // Validate entity.enable_cp_state_b for existence and correct type.
        if (entity.enable_cp_state_b == undefined)
            return false;
        if (typeof entity.enable_cp_state_b !== "boolean")
            return false;
        return true;
    }
}
exports.TestRackEvGpioCommandValidation = TestRackEvGpioCommandValidation;
